(function(){
  var SEL = '.card__media img, .product__media img, .thumbnail img, .b2b-colours__item img';
  var cache = {};
  var pending = {};
  function baseOf(src){ return String(src || '').split('?')[0]; }
  function probeUrl(src){
    try{
      var u = new URL(src, location.href);
      u.searchParams.set('width', '48');
      u.searchParams.delete('height');
      u.searchParams.delete('crop');
      return u.toString();
    }catch(e){ return null; }
  }
  function isWhite(d, w, h){
    var pts = [[0, 0], [w - 1, 0], [(w / 2) | 0, 0], [0, (h / 2) | 0], [w - 1, (h / 2) | 0], [0, h - 1], [w - 1, h - 1]];
    var ok = 0;
    for(var i = 0; i < pts.length; i++){
      var p = (pts[i][1] * w + pts[i][0]) * 4;
      if(d[p + 3] > 250 && d[p] >= 250 && d[p + 1] >= 250 && d[p + 2] >= 250) ok++;
    }
    return ok >= 5;
  }
  function apply(img, white){
    if(white){
      img.classList.add('b2b-whitebg');
      if(img.parentElement) img.parentElement.classList.add('b2b-whitebg-wrap');
    } else {
      img.classList.remove('b2b-whitebg');
    }
  }
  function done(key, white){
    cache[key] = white;
    var list = pending[key] || [];
    delete pending[key];
    list.forEach(function(img){
      if(baseOf(img.currentSrc || img.src) === key) apply(img, white);
    });
  }
  function check(img){
    var src = img.currentSrc || img.src;
    if(!src || src.indexOf('data:') === 0) return;
    var key = baseOf(src);
    if(Object.prototype.hasOwnProperty.call(cache, key)){ apply(img, cache[key]); return; }
    img.classList.remove('b2b-whitebg');
    if(pending[key]){ pending[key].push(img); return; }
    pending[key] = [img];
    var url = probeUrl(src);
    if(!url){ done(key, false); return; }
    var pr = new Image();
    pr.crossOrigin = 'anonymous';
    pr.onload = function(){
      var white = false;
      try{
        var w = 16, h = 16;
        var c = document.createElement('canvas');
        c.width = w; c.height = h;
        var ctx = c.getContext('2d');
        ctx.drawImage(pr, 0, 0, w, h);
        white = isWhite(ctx.getImageData(0, 0, w, h).data, w, h);
      }catch(e){ white = false; }
      done(key, white);
    };
    pr.onerror = function(){ done(key, false); };
    pr.src = url;
  }
  function watch(img){
    if(img.__b2bBg) return;
    img.__b2bBg = true;
    img.addEventListener('load', function(){ check(img); });
    if(img.complete && (img.currentSrc || img.src)) check(img);
  }
  function scan(){ document.querySelectorAll(SEL).forEach(watch); }
  var timer = null;
  function schedule(){ if(timer) return; timer = setTimeout(function(){ timer = null; scan(); }, 150); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  new MutationObserver(schedule).observe(document.documentElement, {childList: true, subtree: true});
})();
